/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

import "./StatusLabel.styles.scss";
import { CustomComponent } from "store/types";
import classNames from "classnames";

type Status = "update" | "error" | "import";

interface StatusLabelProps {
  state: Status;
  onClick?: () => void;
}

const icons: Record<Status, CustomComponent> = {
  update: WarningIcon,
  error: ErrorIcon,
  import: ExitToAppIcon
};

const texts: Record<Status, string> = {
  update: "Update credentials",
  error: "Error",
  import: "Importing files..."
};

export const StatusLabel: React.FC<StatusLabelProps> = ({ state, onClick }) => {
  const Icon = icons[state];
  return (
    <div onClick={onClick} className={classNames("state-label", `state-label--${state}`)}>
      <Icon fontSize="md" />
      {texts[state]}
    </div>
  );
};
